/* eslint-disable @nx/enforce-module-boundaries */
import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Text } from '@mybridge/ui/text';
import { Button } from '@mybridge/ui/button';
import { Input } from '@mybridge/ui/input';
import { Select } from '@mybridge/ui/select';
import { EMPLOYMENT_CHOICES, WORKPLACE_TYPE, EXP_LEVEL } from 'v4/lib/data';
import { getAllCompanyTypePages } from '../../../../../store/actions/companyPages.actions';
import _, { isEmpty } from 'lodash';
import { HStack, Stack, Box } from '@mybridge/ui/layout';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
} from '@mybridge/ui/form-control';
import Link from 'next/link';
import { AutoSuggestLocationFields } from 'v4/components/auto-suggest-location';
import {
  postNewJob,
  UpdatePartialJob,
} from 'v4/store/actions/companyJobs.actions';
import { useForm } from 'react-hook-form';
import { isMobile } from 'react-device-detect';
import { CreateJobsContext } from 'v4/components/company/Layout/context';
import { Checkbox } from '@mybridge/ui';
import { LocationContext, useCurrentLocation } from 'v4/lib/hooks/use-location';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';

const IntroSection = () => {
  const { companyPageTypeList } = useSelector((state) => state.companyPage);
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const { t } = useTranslator();
  const {
    setSelectCompany,
    createOrUpdateJob,
    createJobLoading,
    updateJobLoading,
    isEdit,
    setSection,
    jobDetails,
    setJobDetails,
    whyWorkHere,
    jobUserVerification,
    setJobUserVerification,
  } = useContext(CreateJobsContext);
  const [showCompanyName, setShowCompanyName] = useState(false);
  const direction = useDirection();
  const [country, setCountry] = useState({
    city: jobDetails?.city,
    state: jobDetails?.state,
    country: jobDetails?.country,
    postal: jobDetails?.postal_code,
  });

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    dispatch(getAllCompanyTypePages());
  }, []);

  const onClickNext = (form) => {
    let payload = {};
    if (jobDetails?.id) {
      payload = {
        body: {
          is_draft: false,
          experience_level: form?.experience_level,
          title: jobDetails?.title,
          employment_type: jobDetails?.employment_type,
          country: jobDetails?.country,
          city: jobDetails?.city,
          hiring_company: Number(jobDetails?.hiring_company),
          remote: jobDetails?.remote,
          state: jobDetails?.state,
          postal_code: jobDetails?.postal_code,
        },
        id: jobDetails?.id,
        method: 'PATCH',
      };
    } else {
      payload = {
        ...jobDetails,
        is_draft: true,
        currency_choice: 'USD',
        why_work_here: whyWorkHere ? whyWorkHere : null,
        experience_level: form?.experience_level,
      };
    }
    createOrUpdateJob(payload).then((res) => {
      if (res) {
        setSection(2);
      }
    });
    // setSection(2);
  };
  const jobTitle = watch('title');
  const selectedCompany = watch('hiring_company');
  const employmenType = watch('employment_type');
  const workplaceType = watch('remote');
  const userVerification = watch('userVerify');

  useEffect(() => {
    setJobDetails({
      // ...jobDetails,
      title: jobTitle,
      country: country?.country,
      state: country?.state,
      city: country?.city,
      postal_code: country?.postal,
      employment_type: employmenType,
      remote: workplaceType,
      hiring_company: selectedCompany,
      id: jobDetails?.id,
    });
    setJobUserVerification(userVerification);
  }, [
    jobTitle,
    country,
    workplaceType,
    employmenType,
    selectedCompany,
    userVerification,
  ]);

  useEffect(() => {
    setSelectCompany(
      _.find(companyPageTypeList, (company) => company.id == selectedCompany)
    );
  }, [selectedCompany]);

  // console.log('jobDetails', jobDetails);

  return (
    <Box w="100%">
      <form onSubmit={handleSubmit(onClickNext)}>
        <Stack spacing={4} w="100%">
          <FormControl isInvalid={errors.title}>
            <FormLabel
              mb={0}
              fontSize="md"
              color="brandGray.30"
              fontWeight="regular"
              htmlFor="title"
            >
              {t('jobs.jobTitle') || "Job Title"}*
            </FormLabel>
            <Input
              type="text"
              textTransform="capitalize"
              placeholder={t('jobs.jobTitle') || "Job Title"}
              defaultValue={jobDetails?.title}
              variant="whiteInput"
              color="brandGray.30"
              {...register('title', {
                required: true,
              })}
            />
            {errors.title && (
              <FormErrorMessage mt={0}>{t('createJob.jobTitleRequired') || "Please enter title"}</FormErrorMessage>
            )}
          </FormControl>
          <FormControl isInvalid={errors.hiring_company}>
            <FormLabel
              mb={0}
              fontSize="md"
              color="brandGray.30"
              fontWeight="regular"
              mr={0}
              htmlFor="hiring_company"
            >
              <HStack
                flexDir={['column', 'column', 'row']}
                alignItems="flex-start"
                justifyContent="space-between"
              >
                <Text fontSize="md" color="brandGray.30" fontWeight="regular">{t('createJob.hiringAuthority') || "Hiring Authority"}*</Text>
                {!isMobile && (
                  <Link href="/page/create">
                    <Text
                      fontSize="sm"
                      color="brandPrimary.500"
                      fontWeight="semibold"
                    >
                      {t('createJob.createCompany') || "Create company"}
                    </Text>
                  </Link>
                )}
              </HStack>
            </FormLabel>
            <Select
             style={{ width: '100%', maxWidth: '100%' }}
              placeholder={t('createJob.selectCompany') || "Select company"}
              fontSize="md"
              color="brandGray.700"
              fontWeight="regular"
              background="white"
              defaultValue={jobDetails?.hiring_company}
              {...register('hiring_company', {
                required: true,
              })}
              sx={direction === 'rtl' ? {
                '&': {
                  textAlign: 'left',
                }
              } : {}}
            >
              {/* <option value="0">
                Post job as {userProfileInfo.first_name}{' '}
                {userProfileInfo.last_name}
              </option> */}
              {companyPageTypeList?.map((val) => {
                return (
                  <option value={val.id} key={val.id}>
                    {val.name}
                  </option>
                );
              })}
            </Select>
            {errors.hiring_company && (
              <FormErrorMessage mt={0}>
                {t('createJob.selectHiringCompany') || "Please select hiring company"}
              </FormErrorMessage>
            )}
          </FormControl>
          {showCompanyName && (
            <FormControl isInvalid={errors.company_name}>
              <FormLabel
                mb={0}
                fontSize="md"
                color="brandGray.30"
                fontWeight="regular"
                htmlFor="company_name"
              >
                {t('profileExperience.companyName') || "Company Name"}*
              </FormLabel>
              <Input
                type="text"
                placeholder={t('profileExperience.companyName') || "Company Name"}
                defaultValue={jobDetails.company_name}
                fontSize="md"
                color="brandGray.300"
                fontWeight="regular"
                background="white"
                {...register('company_name', {
                  required: true,
                })}
              />

              {errors.company_name && (
                <FormErrorMessage mt={0}>
                  {t('createJob.enterCompanyName') || "Please enter company name"}
                </FormErrorMessage>
              )}
            </FormControl>
          )}

          <FormControl isInvalid={errors.country}>
            <AutoSuggestLocationFields
              w="100%"
              countryLabel={t('profileExperience.countryRegion') || "Country/Region"}
              cityStateLabel={t('profileExperience.cityDistrict') || "City/District"}
              isRequired
              defaultValue={country?.country ? country : ''}
              // defaultValue={country}
              onChange={(e) => {
                setCountry(e);
                // console.log('country', e)
              }}
              controlFor="job"
              variant="whiteInput"
              countryProps={{ variant: 'whiteInput' }}
              // {...register('country', {
              //   required: false,
              // })}
            />

            {errors.country && (
              <FormErrorMessage mt={0}>
                {t('createJob.enterCountry') || "Please enter your country"}
              </FormErrorMessage>
            )}
          </FormControl>

          <FormControl isInvalid={errors.employment_type}>
            <FormLabel
              mb={0}
              fontSize="md"
              color="brandGray.30"
              fontWeight="regular"
              htmlFor="employment_type"
            >
              {t('createJob.selectEmploymentType') || "Select Employment Type"}*
            </FormLabel>
            <Select
              placeholder={t('createJob.selectEmploymentType') || "Select Employment Type"}
              fontSize="md"
              color="brandGray.700"
              fontWeight="regular"
              background="white"
              defaultValue={jobDetails?.employment_type}
              {...register('employment_type', {
                required: true,
              })}
              sx={direction === 'rtl' ? {
                '&': {
                  textAlign: 'left',
                }
              } : {}}
              style={{ width: '100%', maxWidth: '100%' }}
            >
              {EMPLOYMENT_CHOICES.map((val) => (
                <option value={val.value} key={val.value} w="70%">
                  {t(val.translationKey) || val.label}
                </option>
              ))}
            </Select>
            {errors.employment_type && (
              <FormErrorMessage mt={0}>
                {t('createJob.selectEmploymentTypeError') || "Please select employement type"}
              </FormErrorMessage>
            )}
          </FormControl>

          <FormControl isInvalid={errors.remote}>
            <FormLabel
              mb={0}
              fontSize="md"
              color="brandGray.30"
              fontWeight="regular"
              htmlFor="remote"
            >
              { t('jobs.workplaceType') || "Workplace type"}*
            </FormLabel>
            <Select
              placeholder={t('createJob.selectWorkplaceType') || "Select Workplace type"}
              fontSize="md"
              color="brandGray.700"
              fontWeight="regular"
              background="white"
              defaultValue={jobDetails?.remote}
              {...register('remote', {
                required: true,
              })}
              sx={direction === 'rtl' ? {
                '&': {
                  textAlign: 'left',
                }
              } : {}}
            >
              {WORKPLACE_TYPE.map((val) => (
                <option value={val.value} key={val.value}>
                  {t(val.translationKey) || val.label}
                </option>
              ))}
            </Select>
            {errors.remote && (
              <FormErrorMessage mt={0}>
                {t('createJob.selectWorkplaceTypeError') || "Please select workplace type"}
              </FormErrorMessage>
            )}
          </FormControl>


          <FormControl isInvalid={errors.experience_level}>
            <FormLabel
              mb={0}
              fontSize="md"
              color="brandGray.30"
              fontWeight="regular"
              htmlFor="experience_level"
            >
              {t('createJob.experienceLevel') || "Experience Level"}*
            </FormLabel>
            <Select
              placeholder={t('createJob.selectExperienceLevel') || "Select Experience Level"}
              fontSize="md"
              color="brandGray.700"
              fontWeight="regular"
              background="white"
              defaultValue={jobDetails?.experience_level}
              {...register('experience_level', {
                required: true,
              })}
              sx={direction === 'rtl' ? {
                '&': {
                  textAlign: 'left',
                }
              } : {}}
            >
              {EXP_LEVEL.map((val) => (
                <option value={val.value} key={val.value}>
                   {t(val.translationKey) || val.label}
                </option>
              ))}
            </Select>
            {errors.experience_level && (
              <FormErrorMessage mt={0}>
                {t('createJob.selectExperienceLevelError') || "Please select experience level"}
              </FormErrorMessage>
            )}
          </FormControl>


          {!isEdit && (
            <Button
              height="48px"
              type="submit"
              mt={3}
              variant="primary"
              borderRadius="full"
              isLoading={createJobLoading || updateJobLoading}
              isDisabled={!jobUserVerification}
            // onClick={onClickNext}
            >
              {t('buttons.next') || "Next"}
            </Button>
          )}
          <Text fontSize="12px" color="#9c9c9cff">
            {"Be sure to have valid credit card , posting a job requires a subscription."}
          </Text>
          <FormControl isInvalid={errors.userVerify}>
            <Checkbox
              {...register('userVerify', {
                required: true,
              })}
              defaultChecked={jobUserVerification}
              borderColor={'gray.300'}
            >
              <Text fontSize="12px" color="#9c9c9cff">
                {t('createJob.verifyJobPosting') || "I verify that I have the right to post this job."}
              </Text>
            </Checkbox>
          </FormControl>
        </Stack>
      </form>
    </Box>
  );
};

export default IntroSection;
